import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, Alert, Grid } from '@mui/material';

const SimpleTransactionForm = ({ title, onSubmit, onCancel, type, initialData }) => {
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);
  const [nomorBukti, setNomorBukti] = useState('');
  const [deskripsi, setDeskripsi] = useState('');
  const [jumlah, setJumlah] = useState('');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (initialData) {
      setTanggal(initialData.tanggal ? new Date(initialData.tanggal).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]);
      setNomorBukti(initialData.nomor_bukti || '');
      setDeskripsi(initialData.deskripsi || '');
      setJumlah(initialData.jumlah || '');
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormError('');

    if (!tanggal || !deskripsi || !jumlah) {
      setFormError('Tanggal, Deskripsi, dan Jumlah harus diisi.');
      return;
    }
    
    const numJumlah = parseFloat(jumlah);
    if (isNaN(numJumlah) || numJumlah <= 0) {
        setFormError('Jumlah harus berupa angka positif.');
        return;
    }

    const transactionData = {
      tanggal: new Date(tanggal).toISOString(),
      nomor_bukti: nomorBukti,
      deskripsi,
      jumlah: numJumlah
    };

    onSubmit(transactionData);
  };

  let jumlahLabel = "Jumlah";
  if (type && type.includes('penerimaan')) {
      jumlahLabel = "Jumlah Masuk (Rp)";
  } else if (type === 'penyaluran' || type === 'beban-pengelolaan') {
      jumlahLabel = "Jumlah Keluar (Rp)";
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, width: '100%' }}>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      {formError && <Alert severity="error" sx={{ mb: 2 }}>{formError}</Alert>}

      <Grid container spacing={2}>
        <Grid item xs={12}>
            <TextField
                label="Tanggal"
                type="date"
                fullWidth
                variant="outlined"
                value={tanggal}
                onChange={(e) => setTanggal(e.target.value)}
                InputLabelProps={{ shrink: true }}
                required
            />
        </Grid>
        <Grid item xs={12}>
            <TextField
                label="Nomor Bukti"
                fullWidth
                variant="outlined"
                value={nomorBukti}
                onChange={(e) => setNomorBukti(e.target.value)}
                InputLabelProps={{ shrink: true }}
            />
        </Grid>
        <Grid item xs={12}>
            <TextField
                label={jumlahLabel}
                type="number"
                fullWidth
                variant="outlined"
                value={jumlah}
                onChange={(e) => setJumlah(e.target.value)}
                required
                InputLabelProps={{ shrink: true }}
            />
        </Grid>
        <Grid item xs={12}>
            <TextField
                label="Deskripsi"
                fullWidth
                variant="outlined"
                value={deskripsi}
                onChange={(e) => setDeskripsi(e.target.value)}
                required
                InputLabelProps={{ shrink: true }}
                multiline
                rows={1}
            />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap' }}>
        <Button type="submit" variant="contained" color="primary">
          Simpan
        </Button>
        <Button type="button" variant="outlined" onClick={onCancel}>Batal</Button>
      </Box>
    </Box>
  );
};

export default SimpleTransactionForm;